/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userlogonname2Inputs */

const en_entity_userlogonname2 = /** @type {(inputs: Entity_Userlogonname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Logon Name`)
};

const de_entity_userlogonname2 = /** @type {(inputs: Entity_Userlogonname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldename`)
};

/**
* | output |
* | --- |
* | "User Logon Name" |
*
* @param {Entity_Userlogonname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userlogonname2 = /** @type {((inputs?: Entity_Userlogonname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userlogonname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userlogonname2(inputs)
	return de_entity_userlogonname2(inputs)
});
export { entity_userlogonname2 as "entity_userLogonName" }